/**
 * Converts an unknown value to a display string.
 *
 * - `null` / `undefined` → `''`
 * - objects → `JSON.stringify`
 * - strings → pass-through
 * - numbers, booleans, bigints → `String()`
 * - anything else → `JSON.stringify`
 */
export function formatValue(v: unknown): string {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'boolean' || typeof v === 'bigint') return String(v);
  return JSON.stringify(v) ?? String(v);
}
